import React from 'react';
import MarginIndicatorsPanel from './MarginIndicatorsPanel';
import RobotCommandsTable from './RobotCommandsTable';

function AccountRobotPage({ marginIndicators }) {
  return (
    <div className="account-robot-page">
      <MarginIndicatorsPanel marginIndicators={marginIndicators} variant="account-mobile" />
      <RobotCommandsTable
        variant="embedded"
        showWhenEmpty
        bodyMaxHeight="min(50vh, 360px)"
        groupByBroker
        fluidColumns
        mergePairColumn
        mobileSelectionLayout
      />
    </div>
  );
}

export default AccountRobotPage;
